const METRIKA_COUNTER_ID: MetrikaCounterId = 15808969 as MetrikaCounterId;

export { METRIKA_COUNTER_ID };
